import { cn } from '@/lib/utils';

export interface EmptyChatHeroProps {
  className?: string;
  greeting?: string | null;
  subline?: string | null;
}

export function EmptyChatHero({ className, greeting, subline }: EmptyChatHeroProps) {
  const headline = greeting?.trim() || 'Hi there';
  const secondary = subline?.trim() || 'How can I help you today?';

  return (
    <div className={cn('flex flex-col items-center gap-2 px-4 text-center', className)}>
      <p className="text-2xl font-medium tracking-tight text-foreground md:text-3xl">
        {headline}
      </p>
      <p className="text-lg font-semibold tracking-tight text-primary md:text-xl">
        {secondary}
      </p>
    </div>
  );
}
